export enum Role {
  ACCOUNT_MANAGER = "account_manager",
  PROJECT_MANAGER = "project_manager",
  CLIENT = "client",
}

export enum ClientType {
  INDIVIDUAL = "individual",
  COMPANY = "company",
}

export class OnboardBusinessDto {
  firstName: string;
  lastName: string;
  phoneCode: string;
  phoneNumber: string;
  companyName: string;
  companyCountryOfRegistration: string;
  businessType: string;
  industry: string;
  otherIndustry?: string;
  invitationToken?: string;
  signupSource?: string;
  caseWorkflowEnabled?: boolean;
}

export class CreateBusinessUserDto {
  firstName: string;

  lastName: string;

  email: string;

  phoneCode: string;

  phoneNumber: string;

  // company
  companyName: string;

  companyCountryOfRegistration: string;

  defaultCurrency?: string;

  businessType: string;

  industry: string;

  otherIndustry?: string;

  invitationToken?: string;
  signupSource?: string;
  caseWorkflowEnabled?: boolean;
}
